import { TmElement } from '@thiememeulenhoff/lit-sdk';
import { html, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { tagName } from '../../../helpers';
import { styles } from './select-option.styles';

const tag = tagName('select-option');

@customElement(tag)
export class SelectOptionComponent extends TmElement {
  static override styles = styles;

  @property({ type: Boolean, reflect: true })
  disabled = false;

  @property()
  value = 'option';

  @property({ type: Boolean, reflect: true })
  selected = false;

  #selectedIconRender() {
    return this.selected
      ? html`<div class="check"><a-icon name="check"></a-icon></div>`
      : nothing;
  }

  override render() {
    return html` <div
      data-test="select-option"
      class="container"
      @click=${this.handleOptionClick}
      @keydown=${this.handleKeyDown}
      tabindex=${this.disabled ? '-1' : '0'}
      aria-hidden=${this.disabled}
    >
      <slot></slot>
      ${this.#selectedIconRender()}
    </div>`;
  }

  setSelected(selected: boolean) {
    this.selected = selected;
  }

  handleKeyDown(e: KeyboardEvent) {
    if (e.key === 'Enter') {
      this.handleOptionClick();
    }
  }

  handleOptionClick() {
    if (this.disabled) {
      return;
    }

    this.selected = !this.selected;

    this.#dispatchSelectedEvent();
  }

  #dispatchSelectedEvent() {
    const content = this.getContent();

    this.dispatchLocalEvent({
      eventName: 'option-selected',
      detail: { option: this.value, content },
    });
  }

  getContent() {
    const slot = this.shadowRoot?.querySelector('slot');
    const nodes = slot?.assignedNodes();
    return nodes
      ?.map((node) =>
        node instanceof HTMLElement ? node.outerHTML : node.textContent,
      )
      .join('');
  }

  override firstUpdated() {
    super.connectedCallback();
    if (this.selected) {
      this.#dispatchSelectedEvent();
    }
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'a-select-option': SelectOptionComponent;
  }
}
